import React from 'react'
import { Helmet } from 'react-helmet'
import { Route, Switch, useRouteMatch, NavLink } from 'react-router-dom'
import AppSnackbarProvider from 'components/app-snackbar-provider'
import { ThemeProvider } from '@material-ui/core/styles'
import { ApolloProvider } from '@apollo/client'
import Box from '@material-ui/core/Box'
import GolfCourseIcon from 'components/material-symbol/icons/GolfCourse'
import Shell from 'components/app-shell'
import PGAIcon from 'images/pga-logo-navy.png'
import themes, { extendTheme } from 'themes'
import {
  AchievementsAuthProvider,
  withAchievementsProtectedRoute,
  achievementsApolloClient,
} from 'lib/achievements-auth'
import AchievementsAccountDropdown from 'pages/achievements/components/AchievementsAccountDropdown'

import AchievementsLoginPage from 'pages/achievements/login'
import AchievementsClaimPage from 'pages/achievements/claim'
import AchievementsListPage from 'pages/achievements/list'
import AchievementsDetailPage from 'pages/achievements/detail'

const ProtectedAchievementsList = withAchievementsProtectedRoute(
  AchievementsListPage,
)
const ProtectedAchievementsDetail = withAchievementsProtectedRoute(
  AchievementsDetailPage,
)

const AchievementsRoutes = () => {
  const { path } = useRouteMatch()

  const menuItems = [
    {
      icon: <GolfCourseIcon />,
      label: 'Achievements',
      path: `${path}`,
      exact: true,
    },
  ]

  return (
    <ThemeProvider theme={extendTheme(themes.pgaCoach)}>
      <Helmet>
        <title>PGA Achievements</title>
        <meta
          name="description"
          content="Track and manage your verified PGA achievements"
        />
        <link rel="icon" href="/pga-coach-favicon.ico" />
      </Helmet>
      <ApolloProvider client={achievementsApolloClient}>
        <AchievementsAuthProvider>
          <AppSnackbarProvider
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Switch>
              {/* Public routes without Shell */}
              <Route
                exact
                path={`${path}/claim`}
                component={AchievementsClaimPage}
              />
              <Route
                exact
                path={`${path}/login`}
                component={AchievementsLoginPage}
              />
              {/* Protected routes with Shell */}
              <Shell
                logo={{
                  src: PGAIcon,
                  alt: 'PGA logo',
                  width: '48px',
                  mobileWidth: '48px',
                }}
                menuItems={menuItems}
                showBrandSwitcher={false}
                showAccountDropdown={false}
                toolbarContent={
                  <>
                    <NavLink to={path}>
                      <img
                        src={PGAIcon}
                        alt="PGA logo"
                        style={{ display: 'block', width: '48px' }}
                      />
                    </NavLink>
                    <Box flexGrow={1} />
                    <AchievementsAccountDropdown />
                  </>
                }
              >
                <Route
                  exact
                  path={path}
                  component={ProtectedAchievementsList}
                />
                <Route
                  exact
                  path={`${path}/:id`}
                  component={ProtectedAchievementsDetail}
                />
              </Shell>
            </Switch>
          </AppSnackbarProvider>
        </AchievementsAuthProvider>
      </ApolloProvider>
    </ThemeProvider>
  )
}

export default AchievementsRoutes
